import React from 'react'
import { useLocation } from 'react-router-dom'

function Header() {
  const { pathname } = useLocation()

  // Returns 'nav-link active' if the path matches, otherwise just 'nav-link'
  const navClass = (path) => {
    if (path === '/') return pathname === '/' ? 'nav-link active' : 'nav-link'
    // highlight Services for all service detail pages too
    if (path === '/services') return pathname.startsWith('/services') || pathname === '/webdev' || pathname === '/digital-marketing' || pathname === '/brand-strategy' || pathname === '/database-analysis' || pathname === '/consulting' || pathname === '/mobile-app' ? 'nav-link active' : 'nav-link'
    return pathname.startsWith(path) ? 'nav-link active' : 'nav-link'
  }

  return (
    <>
    <div className="header-absolute">

      {/* Top info bar */}
      <div className="alert fade show bg-primary border-0 rounded-0 text-center overflow-hidden z-index-9 py-2 m-0 d-none d-lg-block" role="alert">
        <div className="container d-flex justify-content-between px-2 px-xl-4">
          <ul className="list-inline d-flex flex-wrap gap-3 text-white mb-0">
            <li className="list-inline-item small fw-light"><i className="bi bi-headset me-2"></i>Call us: <a href="tel:7677607080" className="link-white">+91 76776 07080</a></li>
            <li className="list-inline-item small fw-light"><i className="bi bi-envelope me-2"></i>Email: <a href="mailto:info@arixautomation.com" className="link-white">info@arixautomation.com</a></li>
          </ul>
          <ul className="list-inline mb-0">
            <li className="list-inline-item small text-white">Follow us on: </li>
            <li className="list-inline-item"><a href="https://www.facebook.com/profile.php?id=61593436621403" target="_blank" rel="noreferrer" className="link-white"><i className="bi bi-facebook"></i></a></li>
            <li className="list-inline-item"><a href="https://www.instagram.com/arix.automation" target="_blank" rel="noreferrer" className="link-white"><i className="bi bi-instagram"></i></a></li>
            <li className="list-inline-item"><a href="#" className="link-white"><i className="bi bi-twitter-x"></i></a></li>
            <li className="list-inline-item"><a href="https://www.linkedin.com/company/arixautomation/posts/?feedView=all" target="_blank" rel="noreferrer" className="link-white"><i className="bi bi-linkedin"></i></a></li>
          </ul>
        </div>
      </div>

      {/* Main navbar */}
      <header className="header-sticky bg-transparent">
        <nav className="navbar navbar-expand-xl">
          <div className="container">

            {/* Logo */}
            <a className="navbar-brand me-0" href="/">
              <img className="light-mode-item navbar-brand-item" style={{ height: '60px' }} src="assets/images/logo2.png" alt="logo" />
              <img className="dark-mode-item navbar-brand-item" style={{ height: '60px' }} src="assets/images/logo2.png" alt="logo" />
            </a>

            {/* Nav links */}
            <div className="navbar-collapse collapse" id="navbarCollapse">
              <ul className="navbar-nav navbar-nav-scroll dropdown-hover mx-auto">

                <li className="nav-item">
                  <a className={navClass('/')} href="/">Home</a>
                </li>

                <li className="nav-item">
                  <a className={navClass('/about')} href="/about">About Us</a>
                </li>

                <li className="nav-item">
                  <a className={navClass('/portfolio')} href="/portfolio">Portfolio</a>
                </li>
                <li className="nav-item">
                  <a className={navClass('/services')} href="/services">Services</a>
                </li>

                <li className="nav-item">
                  <a className={navClass('/contact')} href="/contact">Contact us</a>
                </li>

              </ul>
            </div>

            {/* Right buttons */}
            <ul className="nav align-items-center dropdown-hover ms-sm-2">

              

              {/* Schedule a call */}
              <li className="nav-item ms-2 d-none d-sm-block">
                <a href="#" className="btn btn-sm btn-dark mb-0" data-bs-toggle="offcanvas" data-bs-target="#scheduleCall" aria-controls="scheduleCall">
                  <i className="bi bi-calendar-week me-2"></i>Schedule a call
                </a>
              </li>

              {/* Mobile toggler */}
              <li className="nav-item">
                <button className="navbar-toggler ms-sm-3 p-2" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-animation">
                    <span></span>
                    <span></span>
                    <span></span>
                  </span>
                </button>
              </li>
            </ul>

          </div>
        </nav>
      </header>

    </div>
    </>
  )
}

export default Header
